/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface Icd10Option { 
    readonly id: number;
    code: string;
    description: string;
}
export const Icd10Option_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Icd10Option_code_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(15),];

export const Icd10Option_description_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(1023),];


